import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Mail, LogOut, Users, BarChart3, LayoutDashboard, History, Settings, X,
  Plus, CheckCircle2, Sparkles, HelpCircle
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const Sidebar = ({ mobileOpen, setMobileOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const navItems = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard" },
    { icon: Plus, label: "New Campaign", path: "/campaign/new" },
    { icon: History, label: "Campaigns", path: "/campaigns" },
    { icon: Users, label: "Contacts", path: "/contacts" },
    { icon: BarChart3, label: "Analytics", path: "/analytics" },
    { icon: Settings, label: "Brand", path: "/settings" },
    { icon: CheckCircle2, label: "Billing", path: "/billing" },
    { icon: Sparkles, label: "Getting Started", path: "/getting-started" },
    { icon: HelpCircle, label: "Help Guide", path: "/help" },
  ];

  const NavContent = () => (
    <>
      <div className="p-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-afa-lime rounded-xl flex items-center justify-center">
            <Mail className="w-5 h-5 text-afa-navy" />
          </div>
          <div className="flex flex-col">
            <span className="text-base font-bold text-white leading-tight" style={{fontFamily: 'Manrope'}}>Simply Smarter</span>
            <span className="text-sm font-semibold text-afa-lime leading-tight" style={{fontFamily: 'Manrope'}}>Email</span>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-4">
        {navItems.map((item) => (
          <button
            key={item.path}
            data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            onClick={() => { navigate(item.path); setMobileOpen(false); }}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-white/70 hover:bg-white/10 hover:text-white transition-colors mb-1 text-left font-medium"
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-white/10">
        <div className="px-4 py-3 bg-white/10 rounded-xl mb-3">
          <p className="text-sm font-semibold text-white truncate">{user?.company_name}</p>
          <p className="text-xs text-white/60 truncate">{user?.email}</p>
        </div>
        <button
          data-testid="logout-btn"
          onClick={logout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-white/60 hover:bg-rose-500/20 hover:text-rose-300 transition-colors"
        >
          <LogOut className="w-5 h-5" />
          Sign Out
        </button>
      </div>
    </>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex lg:flex-col w-64 bg-gradient-to-b from-[#003858] via-[#004d6e] to-[#119AB3] h-screen fixed left-0 top-0">
        <NavContent />
      </aside>

      {/* Mobile Sidebar */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/50" onClick={() => setMobileOpen(false)} />
          <aside className="absolute left-0 top-0 bottom-0 w-72 bg-gradient-to-b from-[#003858] via-[#004d6e] to-[#119AB3] flex flex-col animate-slide-in">
            <button onClick={() => setMobileOpen(false)} className="absolute right-4 top-4 p-2 text-white">
              <X className="w-5 h-5" />
            </button>
            <NavContent />
          </aside>
        </div>
      )}
    </>
  );
};
